import { Box, DialogTitle, IconButton } from '@mui/material'
import { IconClose } from 'assets/icons'
import { IconBack } from 'components/common/IconCommon'
import { useTranslation } from 'react-i18next'
import theme from 'theme'

const DialogHeader = ({
    canBack,
    titleKey,
    onClose
}) => {

    const { t } = useTranslation()

    return (
        <DialogTitle sx={{ fontSize: 24, color: theme.palette.text.primary, fontWeight: 600 }}>
            <Box display={'flex'} alignItems={'center'}>
                {canBack && <IconButton sx={{ width: 36, height: 36, mr: 1}} aria-label="close" size='small' onClick={onClose} title={t('common:action.back')}>
                    <IconBack colorFill='#73777A'/>
                </IconButton>}
                {t(titleKey)}
            </Box>
            {Boolean(onClose) && <IconButton sx={{ width: 36, height: 36, position: 'absolute', right: 20, top: 20, '& svg': { transform: 'scale(1.25)' } }} aria-label="close" size='small' onClick={onClose}>
                <IconClose />
            </IconButton>}
        </DialogTitle>
    )
}

export default DialogHeader